export default __webpack_public_path__ + "static/media/Super-Carry.943332af.png";